import { FR_ZIP_REGEX } from "./frZip.js";
/**
 * Corse : approximation par seuil (la vraie limite est communale, pas une
 * coupure nette de zip) — vérifiée en live sur 6 communes frontalières (#812) :
 * 1. zip < 20200 -> Corse-du-Sud (2A).
 * 2. zip >= 20200 -> Haute-Corse (2B).
 * 3. Résiduel non éliminé sur une éventuelle commune mal classée (regression
 *    #517-like, cf. header) — accepté : zéro écart sur l'échantillon vérifié.
 */
const CORSE_SOUTH_NORTH_BOUNDARY = 20200;
/**
 * DOM/COM (#812, deux tours de vérification live — corrige deux hypothèses
 * fausses successives du ticket ET d'un premier fix) :
 * 1. Le champ `depcode` d'IGN n'a pas un format unique : l'index `address`
 *    le tronque à 2 chiffres ("97"/"98"), l'index `poi` garde 3 chiffres
 *    (`974`, `978`…) — vérifié en direct sur 7 territoires + le mécanisme
 *    "POI-rescue" (#566) sur un lieu-dit réunionnais.
 * 2. Filtrer sur un seul format exclut TOUJOURS l'autre index en silence :
 *    `depcode=974` vide l'index `address` (aucun résultat) ; `depcode=97`
 *    vide l'index `poi` (désactive le rescue #566 pour les lieux-dits DOM).
 * 3. Fix : envoyer les DEUX formes en une valeur `depcode` séparée par une
 *    virgule ("97,974") — confirmé en direct : IGN accepte ce paramètre en
 *    array et les deux index répondent normalement, comme sans filtre.
 */
const OVERSEAS_PREFIXES = ["97", "98"];
/**
 * Départements métropolitains réels : 01-95 (pas de "00"/"96"/"99"). Un zip
 * syntaxiquement valide mais sans département réel ne doit pas produire un
 * depcode qui viderait le rappel IGN — mieux vaut l'omettre.
 */
function isKnownMetropolitanDepartment(prefix2) {
    const numeric = Number(prefix2);
    return numeric >= 1 && numeric <= 95;
}
/**
 * Résout le département depuis un zip français, ou `null` si le zip n'est
 * pas un code postal français valide, ou si le département dérivé n'existe
 * pas — dégradation silencieuse : l'appelant doit alors omettre le filtre
 * IGN / le centrage département plutôt qu'échouer.
 */
export function resolveFrDepartment(zip) {
    if (!FR_ZIP_REGEX.test(zip)) {
        return null;
    }
    const prefix2 = zip.slice(0, 2);
    if (prefix2 === "20") {
        const centroidKey = Number(zip) < CORSE_SOUTH_NORTH_BOUNDARY ? "2A" : "2B";
        return { ignParam: centroidKey, centroidKey };
    }
    if (OVERSEAS_PREFIXES.includes(prefix2)) {
        const prefix3 = zip.slice(0, 3);
        return { ignParam: `${prefix2},${prefix3}`, centroidKey: prefix3 };
    }
    return isKnownMetropolitanDepartment(prefix2) ? { ignParam: prefix2, centroidKey: prefix2 } : null;
}
//# sourceMappingURL=frDepartment.js.map